// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu-header[data-v-8f625f0c] {\n  margin-left: 1rem;\n  text-align: left;\n}\n.menu-header .menu-header-name[data-v-8f625f0c] {\n  font-size: 1rem;\n  font-weight: bold;\n}\n.menu-header .menu-header-email[data-v-8f625f0c] {\n  font-size: 0.75rem;\n}", ""]);
// Exports
module.exports = exports;
